import { render } from "./InstallWizardReportSetup.vue?vue&type=template&id=2fd89e0b"
import script from "./InstallWizardReportSetup.vue?vue&type=script&lang=js"
export * from "./InstallWizardReportSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__